{
  "account-book": 62454,
  "aim": 62455,
  "alert": 62456,
  "alibaba": 62457,
  "align-center": 62458,
  "align-left": 61701,
  "align-right": 61702,
  "alipay": 62459,
  "alipay-circle": 62460,
  "aliwangwang": 62461,
  "aliyun": 62462,
  "amazon": 62463,
  "android": 62464,
  "ant-cloud": 62465,
  "ant-design": 62466,
  "apartment": 62467,
  "api": 62468,
  "apple": 62469,
  "appstore": 62470,
  "appstore-add": 62471,
  "area-chart": 62472,
  "arrow-down": 61717,
  "arrow-left": 61718,
  "arrow-right": 61719,
  "arrow-up": 61720,
  "arrows-alt": 62473,
  "audio": 62474,
  "audio-muted": 62475,
  "audit": 62476,
  "backward": 62477,
  "baidu": 62801,
  "bank": 62478,
  "bar-chart": 62479,
  "barcode": 62480,
  "bars": 62481,
  "behance": 61730,
  "behance-square": 62482,
  "bell": 61732,
  "bg-colors": 62483,
  "bilibili": 62802,
  "block": 61734,
  "bold": 62484,
  "book": 61736,
  "border": 62485,
  "border-bottom": 62486,
  "border-horizontal": 62487,
  "border-inner": 62488,
  "border-left": 62489,
  "border-outer": 62490,
  "border-right": 62491,
  "border-top": 62492,
  "border-verticle": 62493,
  "borderless-table": 62494,
  "box-plot": 62495,
  "branches": 62496,
  "bug": 61749,
  "build": 62497,
  "bulb": 62498,
  "calculator": 61752,
  "calendar": 61753,
  "camera": 61754,
  "car": 62499,
  "caret-down": 62500,
  "caret-left": 62501,
  "caret-right": 62502,
  "caret-up": 62503,
  "carry-out": 62504,
  "check": 61761,
  "check-circle": 62505,
  "check-square": 62506,
  "chrome": 62507,
  "ci": 62508,
  "ci-circle": 62509,
  "clear": 62510,
  "clock-circle": 62511,
  "close": 62512,
  "close-circle": 62513,
  "close-square": 62514,
  "cloud": 61772,
  "cloud-download": 62515,
  "cloud-server": 62516,
  "cloud-sync": 62517,
  "cloud-upload": 62518,
  "cluster": 62519,
  "code": 61778,
  "code-sandbox": 62520,
  "codepen": 62521,
  "codepen-circle": 62522,
  "coffee": 62523,
  "column-height": 62524,
  "column-width": 62525,
  "comment": 62526,
  "compass": 61786,
  "compress": 62527,
  "console-sql": 62528,
  "contacts": 62529,
  "container": 62530,
  "control": 62531,
  "copy": 61792,
  "copyright": 62532,
  "copyright-circle": 62533,
  "credit-card": 61795,
  "crown": 62534,
  "customer-service": 62535,
  "dash": 62536,
  "dashboard": 62537,
  "database": 61800,
  "delete": 62538,
  "delete-column": 62539,
  "delete-row": 62540,
  "delivered-procedure": 62541,
  "deployment-unit": 62542,
  "desktop": 62543,
  "diff": 62544,
  "dingding": 62545,
  "dingtalk": 62546,
  "disconnect": 62547,
  "discord": 62803,
  "dislike": 62548,
  "docker": 62804,
  "dollar": 62549,
  "dollar-circle": 62550,
  "dot-chart": 62551,
  "dot-net": 62805,
  "double-left": 62552,
  "double-right": 62553,
  "down": 62554,
  "down-circle": 62555,
  "down-square": 62556,
  "download": 61820,
  "drag": 62557,
  "dribbble": 61822,
  "dribbble-square": 62558,
  "dropbox": 61824,
  "edit": 61825,
  "ellipsis": 62559,
  "enter": 62560,
  "environment": 62561,
  "euro": 62562,
  "euro-circle": 62563,
  "exception": 62564,
  "exclamation": 62565,
  "exclamation-circle": 62566,
  "expand": 62567,
  "expand-alt": 62568,
  "experiment": 62569,
  "export": 61837,
  "eye": 61838,
  "eye-invisible": 62570,
  "facebook": 61840,
  "fall": 62571,
  "fast-backward": 62572,
  "fast-forward": 62573,
  "field-binary": 62574,
  "field-number": 62575,
  "field-string": 62576,
  "field-time": 62577,
  "file": 62578,
  "file-add": 62579,
  "file-done": 62580,
  "file-excel": 62581,
  "file-exclamation": 62582,
  "file-gif": 62583,
  "file-image": 62584,
  "file-jpg": 62585,
  "file-markdown": 62586,
  "file-pdf": 62587,
  "file-ppt": 62588,
  "file-protect": 62589,
  "file-search": 62590,
  "file-sync": 62591,
  "file-text": 62592,
  "file-unknown": 62593,
  "file-word": 62594,
  "file-zip": 62595,
  "filter": 62596,
  "fire": 62597,
  "flag": 61868,
  "folder": 61869,
  "folder-add": 62598,
  "folder-open": 62599,
  "folder-view": 62600,
  "font-colors": 62601,
  "font-size": 62602,
  "fork": 62603,
  "form": 62604,
  "format-painter": 62605,
  "forward": 61878,
  "frown": 62606,
  "fullscreen": 62607,
  "fullscreen-exit": 62608,
  "function": 62609,
  "fund": 62610,
  "fund-projection-screen": 62611,
  "fund-view": 62612,
  "funnel-plot": 62613,
  "gateway": 62614,
  "gif": 62615,
  "gift": 62616,
  "github": 61890,
  "gitlab": 62617,
  "global": 62618,
  "gold": 62619,
  "google": 62620,
  "google-plus": 62621,
  "group": 62622,
  "harmony-o-s": 62806,
  "harmony-os": 62807,
  "hdd": 62623,
  "heart": 61898,
  "heat-map": 62624,
  "highlight": 62625,
  "history": 62626,
  "holder": 62627,
  "home": 61903,
  "hourglass": 62628,
  "html5": 62629,
  "idcard": 62630,
  "ie": 62631,
  "import": 62632,
  "inbox": 61909,
  "info": 61910,
  "info-circle": 62633,
  "insert-row-above": 62634,
  "insert-row-below": 62635,
  "insert-row-left": 62636,
  "insert-row-right": 62637,
  "instagram": 61916,
  "insurance": 62638,
  "interaction": 62639,
  "issues-close": 62640,
  "italic": 62641,
  "java": 62808,
  "java-script": 62809,
  "key": 61921,
  "kubernetes": 62810,
  "laptop": 61922,
  "layout": 62642,
  "left": 62643,
  "left-circle": 62644,
  "left-square": 62645,
  "like": 62646,
  "line": 62647,
  "line-chart": 62648,
  "line-height": 62649,
  "link": 61931,
  "linkedin": 61932,
  "linux": 62811,
  "loading": 62650,
  "loading-3-quarters": 62651,
  "lock": 61935,
  "login": 61936,
  "logout": 62652,
  "mac-command": 62653,
  "mail": 61939,
  "man": 61940,
  "medicine-box": 62654,
  "medium": 61942,
  "medium-workmark": 62655,
  "meh": 62656,
  "menu": 61945,
  "menu-fold": 62657,
  "menu-unfold": 62658,
  "merge": 62812,
  "merge-cells": 62659,
  "message": 61949,
  "minus": 61950,
  "minus-circle": 62660,
  "minus-square": 62661,
  "mobile": 61953,
  "money-collect": 62662,
  "monitor": 62663,
  "moon": 62813,
  "more": 62664,
  "muted": 62814,
  "node-collapse": 62665,
  "node-expand": 62666,
  "node-index": 62667,
  "notification": 61960,
  "number": 62668,
  "one-to-one": 62669,
  "open-a-i": 62815,
  "open-ai": 62816,
  "ordered-list": 62670,
  "paper-clip": 62671,
  "partition": 62672,
  "pause": 62673,
  "pause-circle": 62674,
  "pay-circle": 62675,
  "percentage": 62676,
  "phone": 61970,
  "pic-center": 62677,
  "pic-left": 62678,
  "pic-right": 62679,
  "picture": 62680,
  "pie-chart": 61975,
  "pinterest": 62817,
  "play-circle": 62681,
  "play-square": 62682,
  "plus": 61978,
  "plus-circle": 62683,
  "plus-square": 62684,
  "pound": 62685,
  "pound-circle": 62686,
  "poweroff": 62687,
  "printer": 62688,
  "product": 62818,
  "profile": 62689,
  "project": 62690,
  "property-safety": 62691,
  "pull-request": 62692,
  "pushpin": 62693,
  "python": 62819,
  "qq": 61990,
  "qrcode": 62694,
  "question": 62695,
  "question-circle": 62696,
  "radar-chart": 62697,
  "radius-bottomleft": 62698,
  "radius-bottomright": 62699,
  "radius-setting": 62700,
  "radius-upleft": 62701,
  "radius-upright": 62702,
  "read": 62703,
  "reconciliation": 62704,
  "red-envelope": 62705,
  "reddit": 62706,
  "redo": 62707,
  "reload": 62708,
  "rest": 62709,
  "retweet": 62007,
  "right": 62710,
  "right-circle": 62711,
  "right-square": 62712,
  "rise": 62713,
  "robot": 62714,
  "rocket": 62013,
  "rollback": 62715,
  "rotate-left": 62716,
  "rotate-right": 62717,
  "ruby": 62820,
  "safety": 62718,
  "safety-certificate": 62719,
  "save": 62019,
  "scan": 62720,
  "schedule": 62721,
  "scissor": 62722,
  "search": 62723,
  "security-scan": 62724,
  "select": 62725,
  "send": 62726,
  "setting": 62727,
  "shake": 62728,
  "share-alt": 62729,
  "shop": 62030,
  "shopping": 62730,
  "shopping-cart": 62032,
  "shrink": 62731,
  "signature": 62821,
  "sisternode": 62732,
  "sketch": 62733,
  "skin": 62734,
  "skype": 62037,
  "slack": 62735,
  "slack-square": 62736,
  "sliders": 62737,
  "small-dash": 62738,
  "smile": 62739,
  "snippets": 62740,
  "solution": 62741,
  "sort-ascending": 62742,
  "sort-descending": 62743,
  "sound": 62047,
  "split-cells": 62744,
  "spotify": 62822,
  "star": 62049,
  "step-backward": 62745,
  "step-forward": 62746,
  "stock": 62747,
  "stop": 62748,
  "strikethrough": 62749,
  "subnode": 62750,
  "sun": 62823,
  "swap": 62056,
  "swap-left": 62751,
  "swap-right": 62752,
  "switcher": 62753,
  "sync": 62754,
  "table": 62755,
  "tablet": 62062,
  "tag": 62063,
  "tags": 62756,
  "taobao": 62757,
  "taobao-circle": 62758,
  "team": 62759,
  "thunderbolt": 62760,
  "tik-tok": 62824,
  "to-top": 62761,
  "tool": 62762,
  "trademark": 62763,
  "trademark-circle": 62764,
  "transaction": 62765,
  "translation": 62766,
  "trophy": 62075,
  "truck": 62825,
  "twitch": 62826,
  "twitter": 62076,
  "underline": 62767,
  "undo": 62768,
  "ungroup": 62769,
  "unlock": 62770,
  "unordered-list": 62771,
  "up": 62772,
  "up-circle": 62773,
  "up-square": 62774,
  "upload": 62085,
  "usb": 62775,
  "user": 62087,
  "user-add": 62776,
  "user-delete": 62777,
  "user-switch": 62778,
  "usergroup-add": 62779,
  "usergroup-delete": 62780,
  "verified": 62781,
  "vertical-align-bottom": 62782,
  "vertical-align-middle": 62783,
  "vertical-align-top": 62784,
  "vertical-left": 62785,
  "vertical-right": 62786,
  "video-camera": 62099,
  "video-camera-add": 62787,
  "wallet": 62101,
  "warning": 62102,
  "wechat": 62788,
  "wechat-work": 62827,
  "weibo": 62789,
  "weibo-circle": 62790,
  "weibo-square": 62791,
  "whats-app": 62792,
  "wifi": 62793,
  "windows": 62794,
  "woman": 62795,
  "x": 62828,
  "yahoo": 62796,
  "youtube": 62112,
  "yuque": 62797,
  "zhihu": 62798,
  "zoom-in": 62799,
  "zoom-out": 62800
}